import React from "react";
import styles from "./Partners.module.css";
import { Partners } from "../../types";

interface PartnersProps {
  partners: Partners[];
}

const OurPartners: React.FC<PartnersProps> = ({ partners }) => {
  return (
    <section id="mypartners" className={styles.partners}>
      <div className="container">
        <div className={styles.sectionTitle}>
          <h2 className={styles.sectionTitleH2}>Trusted by Industry Leaders</h2>
          <p className={styles.sectionTitleP}>
           Partnering with leading mining companies across the region.
          </p>
          <div className={styles.titleUnderline}></div>
        </div>

        <div className={styles.partnerGrid}>
          {partners.map((partner) => (
            <div key={partner.id} className={styles.partnerCard}>
              <div className={styles.partnerImageContainer}>
                <div className={styles.imageWrapper}>
                  <img
                    src={partner.icon}
                    alt={partner.title}
                    className={styles.partnerImage}
                  />
                  <div className={styles.imageOverlay}></div>
                </div>
              </div>
              <div className={styles.partnerContent}>
                <h3>{partner.title}</h3>
                <p>{partner.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurPartners;